import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnTR: CultureInfo = {
  name: 'en-TR',
  displayName: 'English (Turkey)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-TR',
  parent: CultureInfoEn
};
